import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorTBData = (data) => {

  const heading = get(data, 'hpHeading', null);
  const itemsArr = data.hpItemsRep ? get(data, 'hpItemsRep', []) : [];

  const items = itemsArr.map(item => {

    const img = item.hpItemsImage ? refactorRespImg(item.hpItemsImage, [{
      size: 'default',
      key: 'image_size_840x350'
    },{
      size: 'md',
      key: 'image_size_1280x650',
    },{
      size: 'lg',
      key: 'image_size_1600x800',
    }]) : null;

    return {
      bgImage: img,
      content: {
        title: get(item, 'hpItemsHeading', null),
        text: get(item, 'hpItemsDescription', null),
      },
      thumbnail: item.hpItemsImage ? refactorRespImg(item.hpItemsImage, [{
        size: 'default',
        key: 'image_size_840x350'
      }]) : null,
      alignContent: get(item, 'ibcTextPosition', 'left').toLowerCase()
    }
  })

  return {
    heading: heading,
    items: items,
  }
}

export default refactorTBData;